import StringFormat from '@/utilities/helper/StringFormat'
import { PermissionFilteredType, PermissionType } from '@/api/types/general/PermissionType'
import PermissionDecoder from '@/utilities/auth/permission/decoder/PermissionDecoder'

export default class PermissionFilter {
  private readonly permissions: PermissionType[]

  constructor(permissions: PermissionType[]) {
    this.permissions = permissions
  }

  filter(): PermissionFilteredType[] {
    return this.permissions.map(item => {
      const result = {
        ...item,
        rules: new PermissionDecoder(item.permission.value).decode(),
      }

      if (item.role) {
        result.role = {
          ...item.role,
          value: StringFormat.camelCaseToString(item.role.value),
        }
      }

      return result
    })
  }
}
